import gql from 'graphql-tag';

export default gql`
  mutation signUpUserMutation(
    $login: String!
    $password: String!
    $email: String!
    $firstName: String!
    $lastName: String
    $phone: String
  ) {
    signUpUserMutation(
      login: $login
      password: $password
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
    ) {
      title
      _id
      message
    }
  }
`;
